import React from "react";
import Select from "react-select";
import assignIn from "lodash/assignIn";

interface Option {
  value: string;
  label: string;
}

interface ReactSelectWrapProps {
  options: Option[];
  reactSelectProps: object;
  onChange?: Function;
  isDisabled?:Boolean;
  initialSelectedIndex?: number;
}

interface ReactSelectWrapState {
  choice: Option;
}

class ReactSelectWrap extends React.Component<ReactSelectWrapProps, ReactSelectWrapState> {
  get filteredProps() {
    //Ensure we don't overwrite props the Wrap needs to control
    const filtered = assignIn({}, this.props.reactSelectProps);
    delete filtered.onChange;
    delete filtered.value;
    delete filtered.options;

    return filtered;
  }
  constructor(props: ReactSelectWrapProps) {
    super(props);
    var initialIndex = 0;
    if(props.initialSelectedIndex != null && props.initialSelectedIndex > -1)
    {
      initialIndex = props.initialSelectedIndex;
    }
    this.state = {
      choice: props.options[initialIndex],
    };
  }

  componentDidMount() {
    window.addEventListener("resetStateField", (e: any) => {
      this.setState({ choice: this.props.options[0] });
    });
  }

  render() {
    return (
      <Select
        {...this.filteredProps}
        value={this.state.choice.value}
        onChange={(choice) => {
          this.setState({ choice });
          if (this.props.onChange) this.props.onChange.call(this, choice);
        }}
        options={this.props.options}
        disabled={this.props.isDisabled}
        
      />
    );
  }
}

export default ReactSelectWrap;
